var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteYTube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 21,
    viewBox: "0 0 31 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7812 3.79022C29.609 3.1759 29.2736 2.61972 28.8105 2.18081C28.3344 1.72841 27.7509 1.40479 27.1149 1.24051C24.735 0.613218 15.2002 0.613218 15.2002 0.613218C11.2253 0.567993 7.25128 0.766903 3.30071 1.20883C2.66479 1.38525 2.08233 1.71609 1.60513 2.17194C1.13624 2.62308 0.796618 3.17941 0.619202 3.78896C0.193016 6.0849 -0.0140549 8.41614 0.000782128 10.7512C-0.0144249 13.0843 0.192137 15.4147 0.619202 17.7135C0.792816 18.3206 1.13117 18.8743 1.60132 19.3217C2.07147 19.769 2.65695 20.0922 3.30071 20.2633C5.7123 20.8893 15.2002 20.8893 15.2002 20.8893C19.1802 20.9346 23.1593 20.7357 27.1149 20.2937C27.7509 20.1294 28.3344 19.8058 28.8105 19.3534C29.2794 18.906 29.6127 18.3497 29.78 17.744C30.2173 15.4489 30.4299 13.1167 30.4149 10.7804C30.4478 8.43421 30.2354 6.091 29.7812 3.78896V3.79022ZM12.169 15.0903V6.41344L20.102 10.7525L12.169 15.0903Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteYTube);
export default __webpack_public_path__ + "static/media/whiteYTube.aecafe3a1419dae1bbf64fefb133b7fb.svg";
export { ForwardRef as ReactComponent };